export default __webpack_public_path__ + "static/media/rummy-entertainment.425bcd6c.png";